import store from './index.js'

// 判断是否有缓存
if(sessionStorage.getItem('store')){
	// 更新state
	store.replaceState(
		Object.assign(
		{},
		store.state,
		JSON.parse(sessionStorage.getItem('store'))
		)
	)
	// 移除缓存
	sessionStorage.removeItem('store')
}

// 监听页面刷新 缓存state数据
window.addEventListener('beforeunload',()=>{
	sessionStorage.setItem('store',JSON.stringify(store.state))
})


// WEBPACK FOOTER //
// ./src/store/refresh.js